import { useState } from 'react';

const isLossyEcho = (incoming: string, emitted: string) => {
  // Number('') is 0, so without this a cleared field swallows an external zero.
  if (emitted === '') return incoming === '';

  return Number(incoming) === Number(emitted);
};

export const useNumericInputDraft = (controlledValue: string) => {
  const [draft, setDraft] = useState<string | null>(null);

  const displayValue =
    draft !== null && isLossyEcho(controlledValue, draft)
      ? draft
      : controlledValue;

  if (draft !== null && displayValue !== draft) {
    setDraft(null);
  }

  return [displayValue, setDraft] as const;
};
